import { ForgotPasswordGuard } from './security/forgot-password/forgot-password.guard';
import { AuthModule } from './../auth/auth.module';
import { SecurityService } from './security.service';
import { securityRoutes } from './security.routes';
import { RouterModule } from '@angular/router';
import { SharedModule } from './../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SecurityComponent } from './security/security.component';
import { LoginAndRegisterComponent } from './security/login-and-register/login-and-register.component';
import { ForgotPasswordComponent } from './security/forgot-password/forgot-password.component';
import { ReactiveFormsModule,FormsModule } from '@angular/forms';
import { LoginTypesComponent } from './security/login-types/login-types.component';
import { ResetPasswordComponent } from './security/reset-password/reset-password.component';
import { UserProfileComponent } from './security/user-profile/user-profile.component';

@NgModule({
  imports: [
    CommonModule,    
    SharedModule,
    RouterModule.forChild(securityRoutes)
  ],
  declarations: [SecurityComponent, LoginAndRegisterComponent, ForgotPasswordComponent, LoginTypesComponent, ResetPasswordComponent, UserProfileComponent],
  providers:[SecurityService,ForgotPasswordGuard]
})
export class SecurityModule {
  
 }



// WEBPACK FOOTER //
// ./src/app/security/security.module.ts